import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import { App } from '../components/app/app.jsx';

const parse = (string) => {
    return JSON.parse(string
        .replace(/<\\\/script/g, '</script')
        .replace(/<\\!--/g, '<!--'));
};

const props = parse(document.getElementById('props').innerHTML);

ReactDOM.hydrateRoot(
    document.getElementById('js-content'),
    <>
        <HelmetProvider>
            <App {...props} />
        </HelmetProvider>
    </>
);
